import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Badge } from "~/components/ui";
import { cn } from "~/lib/utils";

type BadgeTone = React.ComponentProps<typeof Badge>["tone"];

/** Maps a change-request status to a badge tone. `processing` is a transient
 *  display-only state shown while a batch review job runs. */
const STATUS_TONE: Record<string, BadgeTone> = {
  open: "status-published",
  committed: "status-approved",
  rejected: "score-c",
  processing: "status-processing",
};

interface ChangeRequestStatusBadgeProps {
  status: string;
  /** Show a spinner + "processing" while a batch review job is in flight. */
  processing?: boolean;
  className?: string;
}

export function ChangeRequestStatusBadge({ status, processing = false, className }: ChangeRequestStatusBadgeProps) {
  const { t } = useTranslation();
  if (processing) {
    return (
      <Badge tone="status-processing" className={cn("gap-1", className)}>
        <Loader2 className="animate-spin" />
        {t("ui.processing")}
      </Badge>
    );
  }
  return (
    <Badge tone={STATUS_TONE[status] ?? "default"} className={className}>
      {status}
    </Badge>
  );
}
